import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Route } from "lucide-react";

export function PathwayCard({ pathway, secondaryPathways }) {
  if (!pathway) return null;
  return (
    <Card className="bg-white/90 shadow-card" data-testid="journey-pathway-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-base flex items-center gap-2">
          <Route className="w-4 h-4 text-primary" />
          Pathway
        </CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-2">
        <p className="font-medium">{pathway.title || pathway.name}</p>
        {pathway.name && pathway.title && pathway.name !== pathway.title && (
          <p className="text-xs text-muted-foreground">{pathway.name}</p>
        )}
        {secondaryPathways?.length > 0 && (
          <div className="flex flex-wrap gap-1">
            {secondaryPathways.map((p) => (
              <Badge key={p.id} variant="outline" className="text-xs">
                {p.title || p.name}
              </Badge>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
